import React, { useEffect, useState } from "react";
import axiosInstance from "services/AxiosInstance";

const BannerResidente = () => {
  const URL = "/api/v3/residentes/banner/";
  const [data, setData] = useState({});

  const fetchData = async () => {
    try {
      const response = await axiosInstance.get(URL);
      setData(response.data);
    } catch (error) {
      // Si falla, simplemente no mostramos el banner
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const banner = data.banner;

  if (!banner?.data?.activo || !banner?.imagen) {
    return null;
  }

  const imagen = (
    <img
      src={banner.imagen}
      alt="Banner"
      className="img-fluid"
      style={{ width: "100%", borderRadius: "0.5rem" }}
    />
  );

  return (
    <div className="card mb-4">
      {banner.data.href ? (
        <a href={banner.data.href} target="_blank" rel="noreferrer">
          {imagen}
        </a>
      ) : (
        imagen
      )}
    </div>
  );
};

export default BannerResidente;
